import { Component, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { SedePuntoAtencion, ServicioLaboratorioService, InconformidadLaboratorioEntity, InconformidadLaboratorioBodyEntity, CitaLaboratorioBodyEntity } from 'src/app/services/servicio-laboratorio.service';
import { FileService } from 'src/app/services/utils/file.service';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { ExcelService } from 'src/app/services/utils/excel.service';
import { HttpErrorResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-header-inconformidad-agenda',
  templateUrl: './header-inconformidad-agenda.component.html',
  styleUrls: ['./header-inconformidad-agenda.component.css']
})
export class HeaderInconformidadAgendaComponent implements OnChanges {

  loading: boolean; // Indicador de carga en header
  canDownload: boolean; // Indicador si existe data
  downloading: boolean; // Indicador de descarga en header
  verJustificacion: boolean = true;

  sedePuntoAtencion: number; // Sede punto atencion elegido

  fechaInicial: string; // Valor fecha inicial del formulario
  fechaFinal: string; // Valor fecha final del formulario
  mensajeError: string // String para mensaje error

  sedesPuntosAtencion: SedePuntoAtencion[] = []; // Lista sedes puntos atencion

  @Input() public objetoInconformidadEntity: InconformidadLaboratorioEntity;
  @Input() public objetoInconformidadEntityBody: InconformidadLaboratorioBodyEntity[] = [];
  @Output() filtrosSeleccionados: EventEmitter<any>;

  constructor( private servicioLaboratorio: ServicioLaboratorioService,
               private servicioArchivo: FileService,
               private servicioFecha: FechaService,
               private servicioExcel: ExcelService) { 
    this.loading = true;
    this.filtrosSeleccionados = new EventEmitter();
  }

  ngOnChanges() {
    this.init();
  }

  async init(){
    if(!this.sedesPuntosAtencion || this.sedesPuntosAtencion.length === 0){
      if(this.objetoInconformidadEntity && this.objetoInconformidadEntity.sedePuntoAtencion != 0){
        this.sedePuntoAtencion = Number(this.objetoInconformidadEntity.sedePuntoAtencion);
      }else{
        this.sedePuntoAtencion = 0;
      }
      this.fechaInicial = this.servicioFecha.getInputValue(new Date().getTime());
      this.fechaFinal = this.servicioFecha.getInputValue(new Date().getTime());
      this.getSedesPuntosAtencion();
    }
  }

  async getSedesPuntosAtencion(){
    try{
      let response = await this.servicioLaboratorio.getSedesPuntosAtencionInconformidad(this.objetoInconformidadEntity);
      if(response != null){
        response.subscribe((data: SedePuntoAtencion[]) => {
          this.sedesPuntosAtencion = data;
          //generar
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error('Error getSedesPuntosAtencion()', err);
          this.sedesPuntosAtencion = [];
          this.loading = false;
        });
      }
    }catch(e){
      console.error('Catch getSedesPuntosAtencion()', e);
      this.loading = false;
    }
  }

  // Listener

  onGenerar(){
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    let obj : InconformidadLaboratorioEntity = {
      codigo: this.objetoInconformidadEntity.codigo,
      fechaInicial : 0,
      fechaFinal : 0,
      sedePuntoAtencion : -1,
      descripcionSedePuntoAtencion : '',
      activaJustificacion : false
    }

    if(inicio === null || inicio.getTime() === 0){
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Inicial</strong>.');
    }else if(fin === null || fin.getTime() === 0 ){
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Final</strong>.');
    }else if(Number(this.sedePuntoAtencion) === 0){
      this.mostrarMensaje('Debe seleccionar el campo <strong>Punto Atención</strong>.');
    }else if(this.servicioFecha.compare(inicio, fin) == 1){
      this.mostrarMensaje('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
    }else{
      obj.fechaInicial = inicio.getTime();
      obj.fechaFinal = fin.getTime();
      obj.sedePuntoAtencion = Number(this.sedePuntoAtencion);
      obj.descripcionSedePuntoAtencion = this.getSedePuntoAtencion(Number(this.sedePuntoAtencion));
      obj.activaJustificacion = this.verJustificacion;
      this.objetoInconformidadEntity = obj;
      this.canDownload = obj.fechaInicial > 0;
    }

    this.filtrosSeleccionados.emit(obj);

  }

  onImprimir(){
    let printContents: any, popupWin: any;

    printContents = document.getElementById('inconformidad-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

  onDescargarPDF(){
    try{
      if(this.validatePDF()){
        this.downloading = true;
        let data = xepOnline.Formatter.Html('inconformidad-print', { resolution : '200'});
        const html = `<!DOCTYPE html><head><meta charset="UTF-8"/><title>Citas Laboratorio</title></head><body>${data}</body></html>`;

        let response = this.servicioArchivo.generatePDF(html, 'Inconformidaes Agenda', 'inconformidadesAgenda');

        response.subscribe((data: any) => { 
          let filename = data.filename;
          this.servicioArchivo.downloadFile(filename)
          .subscribe((data) =>{
            saveAs(data, filename);
            this.downloading = false;
          }, err => {
            this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
            console.error('Error download', err);
            this.downloading = false;
          })
        }, (err: HttpErrorResponse) => {
          console.error('Error', err);
          this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
          this.downloading = false;
        });
      }
    }catch(e){
      
    }
  }

  onDescargarExcel(){
    this.downloading = true;
    const initialData: InconformidadLaboratorioBodyEntity[] = this.objetoInconformidadEntityBody;
    const finalData: any[] = [];

    if(initialData && initialData.length > 0){
      initialData.forEach((d: InconformidadLaboratorioBodyEntity) => {
        let data : any = {
          puntoAtencion : d.sedePuntoAtencion,
          fecha: this.servicioFecha.getDateTimeValue(new Date(d.fecha)),
          identificacion: d.numeroIdentificacion,
          primerNombre: d.primerNombre,
          segundoNombre : d.segundoNombre,
          primerApellido : d.primerApellido,
          segundoApellido : d.segundoApellido,
          telefono : d.telefono,
          usuario: d.usuario
        };
        if(this.verJustificacion){ data.justificacion = d.justificacion;}
        finalData.push(data);
      });
      this.servicioExcel.exportAsExcelFile(finalData, 'inconformidadesAgenda', 'Inconformidades Agenda');
      this.downloading = false;
    }else{
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }
  }

  onJustificacion(v: boolean){
    this.verJustificacion = v; 
  }

  // Auxiliares

  getSedePuntoAtencion(unco:number):string{
    if(unco == -1){
      return 'Todos los puntos atencion';
    }else{
      let spa = this.sedesPuntosAtencion.find((s:SedePuntoAtencion) => {
        return s.unco === unco;
      });

      if(spa){
        return spa.sede.descripcionCorta + '-' + spa.puntoAtencion.descripcion;
      }else{
        return '--';
      }
    }
  }

  validatePDF(): boolean{
    if(!this.objetoInconformidadEntityBody || this.objetoInconformidadEntityBody.length < 500){
      return true;
    }else{
      this.mostrarMensaje('El reporte supera los 500 registros, por favor genere un archivo excel.');
      return false;
    }
  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 3500);
  }

}
